import { Box, Button, FormControlLabel, Switch } from "@mui/material";
import { Input } from "../../../Input";
import {
  InputDiv,
  SummaryDiv,
  RadioDiv,
  InputRow,
  StyledBox,
  InputDivFull,
} from "../styles";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRsvp } from "../../../../contexts/rsvp.context";
import { SpeakersFieldType, RsvpType } from "../../../../types/rsvp/index";
import ColorToggleButton from "../../../ToggleButtonGroup";

type Props = {
  onSubmitNav: () => void;
  isDisabled: boolean;
};

export function Speakers({ onSubmitNav, isDisabled }: Props) {
  const { rsvpId, updateSpeakers, createRsvp, speakers } = useRsvp();
  const obj: SpeakersFieldType = {
    detailsObs: "",
    diferentialActionsObs: "",
    treatGuestsAndVIPsTogether: false,
    treatGuestsAndVIPsTogetherObs: "",
  };
  const methods = useForm({
    defaultValues: obj,
  });
  const { handleSubmit, register, reset, control, watch } = methods;
  const [isSwitchOn, setSwitchOn] = useState(false);
  const [observation, setObservation] = useState("");

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setSwitchOn(checked);
  };

  const handleObservationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setObservation(event.target.value);
  };

  function onSubmit(form: SpeakersFieldType) {
    rsvpId ? updateSpeakers(form) : createRsvp({ speakers: form } as RsvpType);
    onSubmitNav();
  }

  useEffect(() => {
    if (speakers) {
      reset(speakers);
    }
  }, [speakers]);
  return (
    <FormProvider {...methods}>
      <StyledBox onSubmit={handleSubmit(onSubmit)} style={{ marginLeft: 16 }}>
        <h3>7.Palestrantes/Speakers/Convidados VIPs</h3>
        <InputDivFull>
          <SummaryDiv>
            <strong>Detalhes</strong>
            <span style={{ color: "#A1A1A1" }}>
              Algum detalhe específico e importante que devemos saber
            </span>
          </SummaryDiv>
          <RadioDiv>
            <Input
              label="Detalhes importantes"
              placeholder="Insira mais detalhes"
              multiline
              size="small"
              {...register("detailsObs")}
            />
          </RadioDiv>
        </InputDivFull>
        <InputDivFull>
          <SummaryDiv>
            <strong>Ações diferenciais</strong>
            <span style={{ color: "#A1A1A1" }}>Especificar as pessoas</span>
          </SummaryDiv>
          <RadioDiv>
            <Input
              label="Ações especificas"
              placeholder="Insira mais detalhes"
              type="text-area"
              multiline
              size="small"
              {...register("diferentialActionsObs")}
            />
          </RadioDiv>
        </InputDivFull>

        <InputDivFull>
          <SummaryDiv>
            <strong>
              Convidados e Speakers/VIPs podem ser tratados no mesmo ambiente no
              FastRsvp?
            </strong>
            <span style={{ color: "#A1A1A1" }}>
              Padrão de complience limita ou não permite acompanhantes
            </span>
          </SummaryDiv>
          <RadioDiv>
            <div
              style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
            >
              <ColorToggleButton
                name="treatGuestsAndVIPsTogether"
                options={[
                  { label: "Sim", value: true },
                  { label: "Não", value: false },
                ]}
                control={control}
              />
              {/* <FormControlLabel
                control={
                  <Switch checked={isSwitchOn} onChange={handleSwitchChange} />
                }
                label={isSwitchOn ? "Sim" : "Não"}
              />
              {isSwitchOn && (
                <Input
                  value={observation}
                  onChange={handleObservationChange}
                  placeholder="Observações"
                  multiline
                  size="small"
                  style={{ width: "158%" }}
                />
              )} */}
            </div>
            {watch("treatGuestsAndVIPsTogether") && (
              <Input
                {...register("treatGuestsAndVIPsTogetherObs")}
                label="Observações"
                placeholder="Insira mais detalhes"
                multiline
                size="small"
                style={{ width: "100%" }}
              />
            )}
          </RadioDiv>
        </InputDivFull>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            marginTop: 2,
          }}
        >
          <Button disabled={isDisabled} variant="contained" type="submit">
            Salvar e avançar
          </Button>
        </Box>
      </StyledBox>
    </FormProvider>
  );
}
